import { COLOR, Lightbox, Toast } from '@cosuno/cosuno-ui';
import React from 'react';

import Routes from '~/components/Routes';
import HtmlHeadTags from '~/shared/components/HtmlHeadTags';

import AppOutdatedNotifier from './AppOutdatedNotifier';
import DownloadPreparationMessage from './DownloadPreparationMessage';
import NavigationConfirmationPrompt from './NavigationConfirmationPrompt';
import OverdueInvoiceWarning from './OverdueInvoiceWarning';
import { PromptsWrapper } from './PromptsWrapper';
import SubcontractorProfilePrompt from './SubcontractorProfilePrompt';

const AppContent: React.FC = () => (
  <NavigationConfirmationPrompt>
    <AppOutdatedNotifier>
      <HtmlHeadTags title={null} themeColor={COLOR.white} />
      <PromptsWrapper>
        <OverdueInvoiceWarning />
        <SubcontractorProfilePrompt />
      </PromptsWrapper>
      <Toast />
      <Routes />
      <Lightbox />
      <DownloadPreparationMessage />
    </AppOutdatedNotifier>
  </NavigationConfirmationPrompt>
);

export default AppContent;
